import React from "react";
import {
  Menu,
  MenuDivider,
  MenuItem,
  Tooltip,
  Position,
  NonIdealState,
  Intent,
  Button,
  Popover
} from "@blueprintjs/core";
import FadeIn from 'react-fade-in'
import ImageFullScreenable from '../Interludes/ImageFullscreenable'

class CreatePanelConcluslion extends React.Component {
  handleDeleteConclusion = id => {
    const { onDeleteConclusion } = this.props;

    onDeleteConclusion(id);
  };

  handleChangeOrder = (currentIndex, newIndex) => {
    const { onChangeOrder } = this.props;

    onChangeOrder(currentIndex, newIndex);
  };

  orderButton = conclusionId => {
    const { conclusions } = this.props;
    const index = conclusions.findIndex(i => i.id === conclusionId);
    const orderMenu = (
      <Menu>
        <MenuDivider title="Change position" />
        {conclusions.map((element, newIndex) => (
          <MenuItem
            key={newIndex}
            text={newIndex + 1}
            disabled={index === newIndex}
            onClick={() => this.handleChangeOrder(index, newIndex)}
          />
        ))}
      </Menu>
    );
    return (
      <Popover content={orderMenu} position={Position.LEFT}>
        <Button icon="changes" minimal={true} />
      </Popover>
    );
  };

  render() {
    const { conclusions, deleting, onOpenDialog } = this.props;

    if (conclusions.length <= 0)
      return (
        <FadeIn>
          <div>
            <NonIdealState
              icon="media"
              title="No Conclusions Yet"
              description="You did not create conclusions yet"
              action={
                <Button
                  intent={Intent.PRIMARY}
                  disabled={conclusions.length >= 5}
                  rightIcon="add"
                  text="Add a conclusion"
                  onClick={onOpenDialog}
                />
              }
            />
          </div>
        </FadeIn>
      );
    return (
      <FadeIn>
        <div>
          <div className="text-right">
            <Tooltip
              disabled={conclusions.length < 20}
              content="You have reached the maximum limit of conclusions"
              position={Position.TOP_LEFT}
            >
              <Button
                intent={Intent.PRIMARY}
                disabled={conclusions.length >= 20}
                rightIcon="add"
                text="Add a conclusion"
                style={{ marginBottom: "20px" }}
                onClick={onOpenDialog}
              />
            </Tooltip>
          </div>
          <div>
            <table className="bp3-html-table full-width">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>File</th>
                  <th>URL</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {conclusions.map((i, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{i.name}</td>
                    <td>{i.file}</td>
                    <td>
                      {i.type === "VIDEO" && (
                        <a
                          // eslint-disable-next-line
                          target="_blank" href={i.downloadURL}>
                          <Button text="See the video" />
                        </a>
                      )}
                      {i.type === "IMAGE" && (
                        <ImageFullScreenable
                          downloadURL={i.downloadURL}
                          index={i}
                        />)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {this.orderButton(i.id)}
                      <Button
                        icon="trash"
                        loading={deleting}
                        minimal={true}
                        onClick={() => this.handleDeleteConclusion(i.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default CreatePanelConcluslion;
